document.addEventListener("DOMContentLoaded", function() {
  var filter_checked = document.querySelectorAll('.facets__label[facets__label].active');
  // console.log("filter_checked",filter_checked)
  filter_checked.forEach(function(item) {
    if (item.querySelector('input[checked]')) {
      // console.log("item0",item.getAttribute('facets__label'))
      document.querySelector('.custom_collection_filter[filter_val='+ item.getAttribute('facets__label') +']').classList.add('active_filter');
    }
  });

  var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");
  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000);
setTimeout(function() {
  // set value in input box
  if (!document.body.classList.contains('error-404')) {
  // set value in input box
    document.querySelectorAll('[custom_input_search]').forEach(function (inputElement) {
      var savedValue = localStorage.getItem('searchValue');
    
      if (savedValue) {
        inputElement.value = localStorage.getItem('searchValue') || ""; 
      } else {
        localStorage.setItem('searchValue', inputElement.value || '');
      }
      inputElement.addEventListener('input', () => {
        const inputValue = inputElement.value;
        localStorage.setItem('searchValue', inputValue);
      });
    });
  }else{
    localStorage.removeItem('searchValue');  
  }
  },2500);
});

document.querySelectorAll('.product-wrap.custom_collection_filter').forEach(function(item) {
      var filter_label = item.getAttribute('filter_val');
      item.addEventListener('click', function(event) {
        if (item.classList.contains('active_filter')) {          
          document.querySelector('[facets__label='+ filter_label +'] input').click();
          item.classList.remove('active_filter');
        }else{
          // document.querySelector('[facets__label='+ filter_label +']').style.display = "none";
          document.querySelector('[facets__label='+ filter_label +'] input').click();
          // document.querySelector('[facets__label='+ filter_label +']').style.display = "block";
          item.classList.add('active_filter');
          setTimeout(function() {
              //window.scrollTo({ top: '100px', behavior: 'smooth' });
              // smoothScroll(document.querySelector(".filter-toggle-container"));
          },2000);
        }
      });
  });

document.body.addEventListener('click', function(event) {
 if (event.target.matches('[data-store-availability-modal-open]')) {
   // console.log("11111",event.target.closest('[data-store-availability-container]'))
   var parent_c = event.target.closest('[data-store-availability-container]');
   parent_c.querySelector('[modal--product-pickup]').classList.add('modal--opened');
   parent_c.querySelector('[modal__content--opened]').classList.add('modal__content--opened');
 }
});
$("body").on("click", ".modal__close", (function(t) {
  t.preventDefault(),
  $(this).parent().parent().removeClass("modal--opened"),
  $(".modal__content").removeClass("modal__content--opened"),
  $("body").removeClass("menu-opened"),
  $("html, body").animate({
      scrollTop: $("body").attr("scrolltop")
  }, 500)
  }
))

function smoothScroll(target) {
    // Calculate the header height with a fallback value
     var heaser_hight;
      if(window.innerWidth <= 767){
        heaser_hight = document.querySelector('#header');
      }else{
        heaser_hight = document.querySelector('[data-desktop-header]');
      }
    var headerHeight = (heaser_hight?.offsetHeight + 50) || 150;
    var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}

function mobile_size_show() {
  // Attach event listener to a parent element for '.overlay-new'
  document.body.addEventListener('click', function(event) {
    if (event.target.matches('.overlay-new')) {
      event.preventDefault();
      const mobileSizeDiv = event.target.parentElement.querySelector('.mobile-size-div');
      if (mobileSizeDiv) {
        mobileSizeDiv.classList.remove('active');
      }
      const productVariantLink = event.target.parentElement.querySelector('.product-variant-link');
      if (productVariantLink) {
        productVariantLink.querySelectorAll('.collection-product__availability').forEach(function(availability) {
          availability.classList.remove('active');
        });
      }
      event.target.classList.remove('active');
      event.target.closest('.collection-product__fig').querySelectorAll('.collection-product__tags').forEach(function(tag) {
        tag.style.display = 'block';
      });
    }
  });

  // Attach event listener to a parent element for '.mobile-size-div'
  document.body.addEventListener('click', function(event) {
    if (event.target.matches('.mobile-size-div')) {
      event.preventDefault();
      event.target.classList.add('active');
      const productVariantLink = event.target.parentElement.querySelector('.product-variant-link');
      if (productVariantLink) {
        productVariantLink.querySelectorAll('.collection-product__availability').forEach(function(availability) {
          availability.classList.add('active');
        });
      }
      const overlayNew = event.target.parentElement.querySelector('.overlay-new');
      if (overlayNew) {
        overlayNew.classList.add('active');
      }
      event.target.closest('.collection-product__fig').querySelectorAll('.collection-product__tags').forEach(function(tag) {
        tag.style.display = 'none';
      });
    }
  });

  // Add event listener for size selection and add to cart (mobile only)
  document.body.addEventListener('click', function(event) {
    if (event.target.matches('.product-swatch__selector.btn:not(.product-swatch__option--is-soldout)') && window.innerWidth <= 767) {
      event.preventDefault();
      event.stopPropagation();
      
      const selectedSize = event.target.textContent.trim();
      const variantId = event.target.getAttribute('data-variant-id');
      const productWrap = event.target.closest('.collection-product');
      
      if (variantId && productWrap) {
        // Add to cart using AJAX
        addVariantToCart(variantId, selectedSize);
        
        // Hide the size selector
        const mobileSizeDiv = productWrap.querySelector('.mobile-size-div');
        const productVariantLink = productWrap.querySelector('.product-variant-link');
        const overlayNew = productWrap.querySelector('.overlay-new');
        
        if (mobileSizeDiv) mobileSizeDiv.classList.remove('active');
        if (productVariantLink) {
          productVariantLink.querySelectorAll('.collection-product__availability').forEach(function(availability) {
            availability.classList.remove('active');
          });
        }
        if (overlayNew) overlayNew.classList.remove('active');
        
        // Show product tags again
        productWrap.querySelectorAll('.collection-product__tags').forEach(function(tag) {
          tag.style.display = 'block';
        });
      }
    }
  });
}

// Function to add variant to cart via AJAX
async function addVariantToCart(variantId, sizeName) {
  const formData = new FormData();
  formData.append('items[0][id]', variantId);
  formData.append('items[0][quantity]', '1');
  
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const data = await response.json();
    
    // Get updated cart count
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    
    // Update cart count in header
    if (typeof updateCartItemCounts === 'function') {
      updateCartItemCounts(cart.item_count);
    }
    
    // Refresh cart drawer with updated content using existing system
    if (typeof updateCartDrawer === 'function') {
      await updateCartDrawer();
    }
    
    // Update shipping bar if function exists
    if (typeof updateShippingBar === 'function') {
      await updateShippingBar();
    }
    
    // Open cart drawer
    openCartDrawer();
    
    // Apply price formatting if function exists
    if (typeof changePriceFormat === 'function') {
      changePriceFormat();
    }
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    showAddToCartError();
  }
}



// Function to show error message
function showAddToCartError() {
  const errorMsg = document.createElement('div');
  errorMsg.className = 'mobile-cart-error';
  errorMsg.innerHTML = `<span>Error adding to cart. Please try again.</span>`;
  errorMsg.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #dc3545;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 9999;
    font-size: 14px;
    animation: fadeInOut 3s ease;
  `;
  
  document.body.appendChild(errorMsg);
  
  setTimeout(() => {
    if (errorMsg && errorMsg.parentNode) {
      errorMsg.parentNode.removeChild(errorMsg);
    }
  }, 3000);
}
document.addEventListener("DOMContentLoaded", function() {
  function adjustHeader() {
      let header = document.querySelector('.header.header-fixed--true');
      
      if (window.innerWidth >= 768) { // Adjust the width as needed for desktop
          header.style.transform = 'translateY(30px)'; // Adjust the value as needed
      } else {
          header.style.transform = 'translateY(0)';
      }
  }

  // Initial adjustment
  //adjustHeader();

  // Adjust on window resize
  //window.addEventListener('resize', adjustHeader);


//for the cart icon clicked
function openCartDrawer() {
document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}


 
 let cartBtn = document.querySelectorAll(".icon-bag.mini_cart.dropdown_link");
  
  if (cartBtn.length > 0) {
      cartBtn.forEach(function(element) {
          element.addEventListener("click", function(event) {
              
              openCartDrawer();
          });
      });
  } else {
      // console.log("Elements not found.");
  }
});

$(document).ready(function() {

  mobile_size_show();

/*  jQuery Nice Select - v1.0
  https://github.com/hernansartorio/jquery-nice-select
  Made by Hernán Sartorio  */
!function(e){e.fn.niceSelect=function(t){function s(t){t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class")||"").addClass(t.attr("disabled")?"disabled":"").attr("tabindex",t.attr("disabled")?null:"0").html('<span class="current"></span><ul class="list"></ul>'));var s=t.next(),n=t.find("option"),i=t.find("option:selected");s.find(".current").html(i.data("display")||i.text()),n.each(function(t){var n=e(this),i=n.data("display");s.find("ul").append(e("<li></li>").attr("data-value",n.val()).attr("data-display",i||null).addClass("option"+(n.is(":selected")?" selected":"")+(n.is(":disabled")?" disabled":"")).html(n.text()))})}if("string"==typeof t)return"update"==t?this.each(function(){var t=e(this),n=e(this).next(".nice-select"),i=n.hasClass("open");n.length&&(n.remove(),s(t),i&&t.next().trigger("click"))}):"destroy"==t?(this.each(function(){var t=e(this),s=e(this).next(".nice-select");s.length&&(s.remove(),t.css("display",""))}),0==e(".nice-select").length&&e(document).off(".nice_select")):console.log('Method "'+t+'" does not exist.'),this;this.hide(),this.each(function(){var t=e(this);t.next().hasClass("nice-select")||s(t)}),e(document).off(".nice_select"),e(document).on("click.nice_select",".nice-select",function(t){var s=e(this);e(".nice-select").not(s).removeClass("open"),s.toggleClass("open"),s.hasClass("open")?(s.find(".option"),s.find(".focus").removeClass("focus"),s.find(".selected").addClass("focus")):s.focus()}),e(document).on("click.nice_select",function(t){0===e(t.target).closest(".nice-select").length&&e(".nice-select").removeClass("open").find(".option")}),e(document).on("click.nice_select",".nice-select .option:not(.disabled)",function(t){var s=e(this),n=s.closest(".nice-select");n.find(".selected").removeClass("selected"),s.addClass("selected");var i=s.data("display")||s.text();n.find(".current").text(i),n.prev("select").val(s.data("value")).trigger("change")}),e(document).on("keydown.nice_select",".nice-select",function(t){var s=e(this),n=e(s.find(".focus")||s.find(".list .option.selected"));if(32==t.keyCode||13==t.keyCode)return s.hasClass("open")?n.trigger("click"):s.trigger("click"),!1;if(40==t.keyCode){if(s.hasClass("open")){var i=n.nextAll(".option:not(.disabled)").first();i.length>0&&(s.find(".focus").removeClass("focus"),i.addClass("focus"))}else s.trigger("click");return!1}if(38==t.keyCode){if(s.hasClass("open")){var l=n.prevAll(".option:not(.disabled)").first();l.length>0&&(s.find(".focus").removeClass("focus"),l.addClass("focus"))}else s.trigger("click");return!1}if(27==t.keyCode)s.hasClass("open")&&s.trigger("click");else if(9==t.keyCode&&s.hasClass("open"))return!1});var n=document.createElement("a").style;return n.cssText="pointer-events:auto","auto"!==n.pointerEvents&&e("html").addClass("no-csspointerevents"),this}}(jQuery); 
$('.chosen-select').niceSelect();
$('.model-dropdown').niceSelect();
 $('.nice-select ul li').click(function (e) {
  // console.log(e.target.getAttribute('data-value'));
   if (document.querySelector('body').classList.contains('product-giftcard')) {
     console.log('e',e.target.closest('.product-option'))
     var parentNo = e.target.closest('.product-option');
     var sortBySelect = parentNo.querySelector(".chosen-select"); 
    sortBySelect.value = e.target.getAttribute('data-value');
    sortBySelect.dispatchEvent(new Event("change"));
   } else{
    var sortBySelect = document.querySelector(".chosen-select"); 
    sortBySelect.value = e.target.getAttribute('data-value')
    sortBySelect.dispatchEvent(new Event("change")); 
   }
});
const options_cust = document.querySelectorAll('.chosen-select option.disabled') || null;
if(options_cust){
  options_cust.forEach((option) =>{
    // console.log("option",option.value)
    document.querySelector(`[data-value = '${option.value}']`).classList.add('disable');
  });
}
});

document.addEventListener("DOMContentLoaded", function() {
  var productInfoElem = document.querySelector(".product__info-container");
  var addToCart =  document.querySelector(".product-atc-btn-wrap.active");
  if(productInfoElem){var errorMsgElem = productInfoElem.querySelector('.error-msg');}
  
  function handleOptionChange() {
    if(document.querySelector("body").classList.contains('product')){
      var selectedOption = productInfoElem.querySelector(".list .option.selected");
      if (selectedOption && selectedOption.getAttribute('data-value') !== "") {
        addToCart.classList.remove('active');
         errorMsgElem.textContent = '';
      }
  }else if (document.querySelector("body").classList.contains('product-giftcard')) {
  
            // active class remove JS 
      var selectedOptions = productInfoElem.querySelectorAll(".list .option.selected");
      var allValid = true; // Flag to check if all options are valid
      
      selectedOptions.forEach(function (selectedOption) {
          // console.log('selectedOption', selectedOption);
          if (
              !selectedOption ||
              selectedOption.getAttribute('data-value') === "" ||
              selectedOption.classList.contains('disabled')
          ) {
              allValid = false; // If any option is invalid, set the flag to false
          }
      });
      
      // If all options are valid, remove the 'active' class
      if (allValid) {
          // console.log('active remove');
          addToCart.classList.remove('active');
          errorMsgElem.textContent = '';
      } else {
        // console.log('active not removed, some options are invalid');
      }
    }
  }
  
  if(addToCart){
    addToCart.addEventListener('click',function(){
      if(addToCart.classList.contains('active')){
        errorMsgElem.textContent = 'Please select size';
      }
    });
  }
  if(productInfoElem){
    var options = productInfoElem.querySelectorAll(".list .option");
    options.forEach(function(option) {
      option.addEventListener('click', function() {
        setTimeout(function(){
          handleOptionChange();  
        },100);
      });
    });
  }
});
  
function toggleModal(){
  let modalSelector = document.querySelector('.product__model-info .product__model-selector');
      if(modalSelector){
         modalSelector.classList.add('product__model-selector--active');
      }  
}

var modelSizeElem = document.querySelector(".nice-select.model-dropdown");
var defaultSelector = document.querySelector(".model-dropdown.model-selector");
  // console.log("modelsizeElem",modelSizeElem);
  if(modelSizeElem){
    var sizeOptions = modelSizeElem.querySelectorAll(".option");
    if(sizeOptions.length){
      sizeOptions.forEach(function(sizeOption) {
        sizeOption.addEventListener('click',function(){
          var value = sizeOption.getAttribute("data-value");
          // console.log("Value :--",value);
          if(defaultSelector){
            var options = defaultSelector.querySelectorAll("option");
            if(options.length){
              options.forEach(function(option){
                var val = option.getAttribute('value');
                // console.log("Val",val);
                if(value == val){
                  var productTemplate = option.getAttribute('data-product-template');
                  // Get all elements with the class 'product-size-gallery'
                  const galleries = document.querySelectorAll('.product-size-gallery');
                  // Hide all galleries and remove 'hidden' class from the corresponding one
                  galleries.forEach(gallery => {
                    document.querySelector(".product-media-gallery.gallery-wrap")?.classList.add('hidden');
                      gallery.classList.add('hidden');
                      if (gallery.getAttribute('data-product-template') === productTemplate) {
                          gallery.classList.remove('hidden');
                          if (window.innerWidth < 767) {
                            destroySlider();
                            initializeFlickity(productTemplate);
                          }
                          toggleModal();
                      }
                  });
                }
              });
            }
          }
        });
      });
    }
    
  }


function checkScreenWidth() {
  if ($(window).width() <= 798) {
    initializeFlickity('defult');
  } else {
    if ($('.product_gallery').data('flickity')) {
      // Destroy Flickity instance if it exists on larger screens
      $('.product_gallery').flickity('destroy');
    }
  }
}

function initializeFlickity(tempName) {
  var carousels = document.querySelectorAll('.product_gallery[product_temp_name="' + tempName + '"]');

  carousels.forEach(function (carousel) {
    if (!carousel.flickityInstance) {
      carousel.flickityInstance = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        wrapAround: true,
        prevNextButtons: true,
      });
    }
  });
}

function destroySlider() {
  var carousels = document.querySelectorAll('.product_gallery');

  carousels.forEach(function (carousel) {
    if (carousel.flickityInstance) {
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null; // Clear instance reference
    }
  });
}

// Handle Gift Card Selection
var giftCardTemplate = document.querySelector(".product__info-container.giftcard");
var mediaImages = document.querySelectorAll(".product_gallery .gallery-cell");

if (giftCardTemplate) {
  setTimeout(function () {
    var optionSelector = giftCardTemplate.querySelector(".nice-select.design-values ul");

    if (optionSelector) {
      var optionBlocks = optionSelector.querySelectorAll("li");

      if (optionBlocks.length) {
        optionBlocks.forEach(function (optionBlock) {
          optionBlock.addEventListener('click', function (e) {
            e.preventDefault();
            var selectedValue = "Gift Card | " + optionBlock.getAttribute("data-value");

            mediaImages.forEach(function (mediaImage) {
              var mediaAlt = mediaImage.getAttribute("media-alt");

              if (selectedValue === mediaAlt) {
                if (window.innerWidth < 798) {
                  var carousel = mediaImage.closest('.product_gallery');
                  // console.log(":carousel",carousel)
                  if (carousel && carousel.flickityInstance) {
                    carousel.flickityInstance.selectCell(mediaImage, false, true); // Select specific cell
                  } else {
                    // console.error('Flickity instance not found for carousel:', carousel);
                  }
                } else {
                  // console.log("me",mediaImages)
                  mediaImages.forEach(function (img) {
                    img.classList.add('hidden'); // Hide all images
                  });
                  mediaImage.classList.remove('hidden'); // Show the matching image
                }
              }
            });
          });
        });
      }
    }
  }, 2000);
}

// Handle screen resizing
window.addEventListener('resize', checkScreenWidth);

// Initial check on page load
checkScreenWidth();



if (window.innerWidth > 767) {
const itemsPerLoad = 6; // Number of items to show initially and on each click

// Function to show gallery cells
function showItems(galleryCells, numberToShow, itemsShown) {
  const totalCells = galleryCells.length;
  const endIndex = Math.min(itemsShown + numberToShow, totalCells);

  // Show the next set of items
  for (let i = itemsShown; i < endIndex; i++) {
    galleryCells[i].classList.remove('hide');
  }

  // Update the count of items currently shown
  itemsShown = endIndex;

  return itemsShown;
}

// Find the gallery that does NOT have the 'hidden' class
const activeGallery = document.querySelector('.product-size-gallery:not(.hidden), .product-media-gallery:not(.hidden)');

if (activeGallery) {
  const galleryCells = activeGallery.querySelectorAll('.gallery-cell');
  const loadMoreBtn = activeGallery.querySelector('.pdp-load-more');
  let itemsShown = 0; // Track how many items are currently shown in this gallery
  const totalCells = galleryCells.length;

  // Initially hide all gallery items
  galleryCells.forEach(function (cell) {
    cell.classList.add('hide');
  });

  // Show the first set of items for the active gallery
  itemsShown = showItems(galleryCells, itemsPerLoad, itemsShown);

  // Show the load more button if there are more items
  if (itemsShown < totalCells) {
    loadMoreBtn.style.display = 'inline-block';
  }

    if(loadMoreBtn){
      // Add event listener to the "Load More" button
      loadMoreBtn.addEventListener('click', function () {
        // Show the next set of items for this active gallery
        itemsShown = showItems(galleryCells, itemsPerLoad, itemsShown);
    
        // Hide the button if all items are now shown
        if (itemsShown >= totalCells) {
          loadMoreBtn.style.display = 'none';
        }
      });
    }
  }
}

var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

// Delay hiding elements to allow Tolstoy to add content
setTimeout(function() {
  tolstoyTiles.forEach(function (tile) {
    // Check if the tile still has no child nodes after the delay
    if (!tile.hasChildNodes()) {
      tile.style.display = "none";
    }
  });
}, 2000);

var custom_image_slider_ = document.querySelectorAll('[custom_slider_data_home]');
if(custom_image_slider_){
custom_image_slider_.forEach(carousel => {
   flkty_img_tab = new Flickity(carousel, {
      cellAlign: 'left',
      prevNextButtons: true,
      pageDots: true,
      wrapAround: false,
     contain:true
    });
  });
}

var custom_image_slider = document.querySelectorAll('.custom_image_slider');
if(custom_image_slider){
custom_image_slider.forEach(carousel => {
   flkty_img_tab = new Flickity(carousel, {
          accessibility: false,
          autoPlay: false,
          pauseAutoPlayOnHover: false,
          cellAlign: 'left',
          contain: false,
          draggable: true,
          friction: 0.2,
          initialIndex: 0,
          lazyLoad: true,
          percentPosition: true,
          prevNextButtons: true,
          pageDots: true,
          resize: true,
          rightToLeft: false,
          setGallerySize: true,
          watchCSS: false,
          wrapAround: false
    });
  });

}

const tabButtons = document.querySelectorAll('.tab-link-btn');
const tabContents = document.querySelectorAll('.tab-collection');
const tabLinkBg = document.querySelector('.tab-link-bg');
var flkty_tab;
var flkty_img_tab;

function initializeSlider(index) {
  const tab_slider = document.querySelector(`.tab-content-${index + 1} .custom_slider_tab`);
  const tab_slider_img = document.querySelectorAll(`.tab-content-${index + 1} .custom_slider_img.tab_img_course-${index + 1}`);
  
  if (tab_slider) {
    flkty_tab = new Flickity(tab_slider, {
        cellAlign: 'center',
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false,
       contain:true,
      groupCells: 2
    });
  }
  if (tab_slider_img) {
    tab_slider_img.forEach(carousel => {
     flkty_img_tab = new Flickity(carousel, {
            accessibility: false,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            cellAlign: 'center',
            contain: false,
            draggable: true,
            friction: 0.2,
            initialIndex: 0,
            lazyLoad: true,
            percentPosition: true,
            prevNextButtons: true,
            pageDots: true,
            resize: true,
            rightToLeft: false,
            setGallerySize: true,
            watchCSS: false,
            wrapAround: false
      });
    });
  }
}

function destroySlider() {
  if (flkty_tab || flkty_img_tab) {
      flkty_tab.destroy();
      flkty_img_tab.destroy();
      flkty_tab = null;
      flkty_img_tab = null;
  }
}

tabButtons.forEach((btn, index) => {
  btn.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      btn.classList.add('active');

      // console.log(index + 1)
      tabContents.forEach(content => content.classList.add('hidden'));
      document.querySelector(`.tab-content-${index + 1}`).classList.remove('hidden');

      destroySlider();
      initializeSlider(index);
  });
});    
initializeSlider(0);


if(window.innerWidth < 768) {
 var filter_main_div = document.querySelectorAll('.custom_detail_filter');
    filter_main_div.forEach(function(element) {
        element.removeAttribute('open');
    });
}else{
  // header div
  
  // $( ".header-wrap" ).wrapAll( "<div class='header-wrap-new' />");
  // $(window).on('load', function() {
  //   var headerheight = $(".header-wrap-new").height();
  //   $(".section-wrapper").css("margin-top",headerheight);
  // });
}